import React from 'react';

import CustomBlock from 'uicontainers/apps/survey/CustomBlock';

const Quota = () => {
  return <CustomBlock />;
};

export default Quota;
